import React from 'react';
import { useI18n } from '../../contexts/I18nContext';

/**
 * Two-state pill switch used at the top of every admin tab.
 * Super-admin only; rendering is the caller's responsibility (gate on role).
 *
 * `value` is the boolean state — `false` means "active", `true` means "archived".
 * `onChange` receives the new boolean.
 */
export default function ArchiveToggle({ value, onChange }) {
  const { t } = useI18n();
  const options = [
    { v: false, label: t('admin_view_active') },
    { v: true,  label: t('admin_view_archived') },
  ];
  return (
    <div
      data-testid="admin-archive-toggle"
      className="inline-flex items-center gap-1 bg-bg-alt border border-stone_line rounded-full p-1"
      role="tablist"
      aria-label={t('admin_view_active')}
    >
      {options.map((opt) => (
        <button
          key={String(opt.v)}
          type="button"
          role="tab"
          aria-selected={value === opt.v}
          onClick={() => onChange(opt.v)}
          data-testid={`admin-archive-toggle-${opt.v ? 'archived' : 'active'}`}
          className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${
            value === opt.v
              ? 'bg-white text-ink shadow-sm'
              : 'text-ink-soft hover:text-ink'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
